import script from "./AvaliabilitySection.vue?vue&type=script&lang=ts&setup=true"
export * from "./AvaliabilitySection.vue?vue&type=script&lang=ts&setup=true"

import "./AvaliabilitySection.vue?vue&type=style&index=0&id=dc49b00c&lang=scss&scoped=true"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc49b00c"]])

export default __exports__